export default __webpack_public_path__ + "static/media/folder.0d98ecc5.webp";